import React from 'react';

import { Dialog } from '@neptune/shared/venus-ui';

import ContactSales from 'components/contact-sales/ContactSales';

type MembersLimitReachedModalProps = {
  isOpen: boolean;
  close: () => void;
};

export const MembersLimitReachedModal: React.FC<MembersLimitReachedModalProps> = ({
  isOpen,
  close,
}) => {
  return (
    <Dialog
      isOpen={isOpen}
      title="Invitations limit reached"
      primaryButtonLabel="OK"
      onPrimaryButtonClick={close}
      onClose={close}
    >
      <Dialog.Text>
        You have reached limit of available invitations. If you want to invite more members to your
        workspace, you can{' '}
        <span onClick={close}>
          <ContactSales>contact sales</ContactSales>
        </span>
        .
      </Dialog.Text>
    </Dialog>
  );
};
